import React, { useEffect, useState } from 'react';
import { Trophy, Loader2 } from 'lucide-react';
import { fmtEUR } from './api';

export const ClassementCoopers = ({ api, refreshKey }) => {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.classement().then(setRows).catch(() => setRows([])); }, [api, refreshKey]);
  if (rows === null) return <Loader2 className="h-4 w-4 animate-spin text-violet-500" />;
  return (
    <section className="rounded-xl border border-slate-200 bg-white p-4 space-y-2" data-testid="ia-classement-coopers">
      <h4 className="flex items-center gap-2 text-sm font-semibold text-slate-800"><Trophy className="h-4 w-4 text-amber-500" /> Classement des COOPER'S — devis IA</h4>
      {rows.length === 0 ? <p className="text-xs text-slate-400">Aucun devis pour le moment.</p> : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="text-xs text-slate-500 bg-slate-50">
              <tr>
                <th className="text-left p-2">#</th><th className="text-left p-2">COOPER'S / créateur</th>
                <th className="text-right p-2">Générés</th><th className="text-right p-2">Envoyés</th><th className="text-right p-2">Signés</th>
                <th className="text-right p-2">Payés</th><th className="text-right p-2">Taux signature</th>
                <th className="text-right p-2">Montant signé TTC</th><th className="text-right p-2">Encaissé TTC</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r, i) => (
                <tr key={r.email} className="border-t border-slate-100" data-testid={`ia-classement-row-${i}`}>
                  <td className="p-2 font-semibold text-slate-500">{i + 1}</td>
                  <td className="p-2"><p className="font-medium text-slate-800">{r.nom}</p><p className="text-[11px] text-slate-400">{r.email}{r.role ? ` · ${r.role}` : ''}</p></td>
                  <td className="p-2 text-right">{r.generes}</td><td className="p-2 text-right">{r.envoyes}</td>
                  <td className="p-2 text-right font-semibold text-emerald-700">{r.signes}</td><td className="p-2 text-right">{r.payes}</td>
                  <td className="p-2 text-right">{r.taux_signature} %</td>
                  <td className="p-2 text-right">{fmtEUR(r.montant_signe_ttc)}</td><td className="p-2 text-right">{fmtEUR(r.encaisse_ttc)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
};
